var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.381 7.18a.41.41 0 0 0 .046-.125l.495-2.641a.67.67 0 0 0-1.32-.238l-.244 1.32a6.087 6.087 0 0 0-10.946.555.66.66 0 0 0 .617.909.66.66 0 0 0 .61-.414 4.674 4.674 0 0 1 4.41-2.911 4.733 4.733 0 0 1 4.12 2.363L11.08 5.82a.669.669 0 1 0-.211 1.32l2.806.47h.105a.615.615 0 0 0 .225-.04.219.219 0 0 0 .066-.04.515.515 0 0 0 .132-.073l.053-.066a.707.707 0 0 0 .092-.105.387.387 0 0 0 .033-.106zm-1.175 2.443a.66.66 0 0 0-.865.37 4.673 4.673 0 0 1-4.383 2.885 4.734 4.734 0 0 1-4.12-2.364l1.09.178h.105a.662.662 0 1 0 .106-1.32l-2.806-.456a.601.601 0 0 0-.218 0h-.053a.76.76 0 0 0-.211.093.66.66 0 0 0-.12.119l-.058.066a.554.554 0 0 0-.047.125.29.29 0 0 0-.046.112l-.495 2.641a.66.66 0 0 0 .528.806h.119a.66.66 0 0 0 .66-.542l.244-1.32a6.086 6.086 0 0 0 10.946-.548.66.66 0 0 0-.376-.845z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidSync);
export default __webpack_public_path__ + "static/media/SolidSync.22deaa3f.svg";
export { ForwardRef as ReactComponent };